import v, { stdSerializers as p, symbols as m } from "pino";
import { z as h } from "zod";
const N = ["debug", "info", "warn", "error", "fatal", "audit"], _ = h.enum(N), E = !process.env.NODE_ENV || process.env.NODE_ENV === "production", L = process.env.NEXT_PHASE === "phase-production-build", R = "process", d = /* @__PURE__ */ Symbol.for("@formbricks/logger/process-handlers-attached"), S = /[/\\]apps[/\\]web$/, O = "node_modules/pino-opentelemetry-transport/lib/pino-opentelemetry-transport.js", f = () => globalThis[R], b = () => `${f().cwd().replace(S, "")}/${O}`, l = () => {
  let e = "info";
  E && (e = "warn"), L && (e = "error");
  const r = process.env.LOG_LEVEL, t = _.safeParse(r);
  return t.success && (e = t.data), e;
}, I = {
  level: l(),
  serializers: {
    err: p.err,
    req: p.req,
    res: p.res
  },
  customLevels: {
    debug: 20,
    info: 30,
    warn: 40,
    error: 50,
    fatal: 60,
    audit: 90
  },
  useOnlyCustomLevels: !0,
  timestamp: !0,
  name: "formbricks"
}, P = () => {
  const e = process.env.NEXT_RUNTIME === "edge", r = process.env.NEXT_RUNTIME === "nodejs" && process.env.OTEL_LOGS_ENABLED === "1" && !!process.env.OTEL_EXPORTER_OTLP_ENDPOINT, t = process.env.OTEL_SERVICE_NAME ?? "formbricks", c = process.env.npm_package_version ?? "0.0.0", i = () => ({
    target: b(),
    options: {
      loggerName: t,
      serviceVersion: c,
      resourceAttributes: {
        "service.name": t,
        "service.version": c,
        "deployment.environment": process.env.ENVIRONMENT ?? process.env.NODE_ENV ?? "development"
      }
    },
    level: l()
  }), s = {
    target: "pino-pretty",
    options: {
      colorize: !0,
      levelFirst: !0,
      translateTime: "SYS:standard",
      ignore: "pid,hostname,ip,requestId",
      customLevels: "trace:10,debug:20,info:30,warn:40,error:50,fatal:60,audit:90",
      useOnlyCustomProps: !0
    },
    level: l()
  };
  if (!E)
    return e ? void 0 : r ? { targets: [s, i()] } : { target: s.target, options: s.options };
  if (r)
    return { targets: [{
      target: "pino/file",
      options: { destination: 1 },
      // stdout
      level: l()
    }, i()] };
}, u = P(), A = u !== void 0 && "targets" in u, w = {
  ...I,
  transport: u,
  ...!A && {
    formatters: {
      level: (e) => ({ level: e })
    }
  }
}, o = v(w), y = (e) => {
  const r = e instanceof Error ? e.stack ?? e.message : String(e);
  f().stderr.write(`[logger] Pino transport error: ${r}
`);
}, C = (e) => {
  if (process.env.NEXT_RUNTIME !== "nodejs") return;
  e[m.streamSym]?.on?.("error", y);
};
C(o);
const D = {
  debug: o.debug.bind(o),
  info: o.info.bind(o),
  audit: o.audit.bind(o),
  warn: o.warn.bind(o),
  error: o.error.bind(o),
  fatal: o.fatal.bind(o)
}, G = {
  ...D,
  withContext: (e) => o.child(e),
  request: (e) => o.child({
    method: e.method,
    url: e.url
  })
}, g = G, a = (e, r) => {
  r && g.error(r, `Error during shutdown (${e})`), g.info({ event: e }, "Process is exiting"), o.flush();
}, M = () => {
  if (process.env.NEXT_RUNTIME !== "nodejs") return;
  const e = process;
  if (e[d]) return;
  e[d] = !0;
  const r = [], t = (n) => a("uncaughtException", n), c = (n) => a("unhandledRejection", n), i = () => a("SIGTERM"), s = () => a("SIGINT");
  try {
    process.on("uncaughtException", t), r.push(() => process.off("uncaughtException", t)), process.on("unhandledRejection", c), r.push(() => process.off("unhandledRejection", c)), process.on("SIGTERM", i), r.push(() => process.off("SIGTERM", i)), process.on("SIGINT", s), r.push(() => process.off("SIGINT", s));
  } catch (n) {
    throw r.reverse().forEach((T) => T()), Reflect.deleteProperty(e, d), n;
  }
};
if (process.env.NEXT_RUNTIME === "nodejs")
  try {
    M();
  } catch (e) {
    g.error(e, "Error attaching process event handlers");
  }
export {
  g as logger
};
